import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import { $isContentDetailsLoading } from '~/processes/content-details-loading/model'
import { Footer } from '~/shared/ui/components/Footer'

ContentFooter.displayName = 'ContentFooter'
export function ContentFooter(): JSX.Element | null {
  const hide = useUnit($isContentDetailsLoading)

  if (hide) {
    return null
  }

  return <Footer />
}
